import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form } from 'redux-form';
import { reduxFormValidateEmailAddress } from 'appSrc/utils/reduxFormValidate';
import { PrimaryButton } from 'appSrc/components/UI';
import { FormTextField, FormTextArea } from 'appSrc/components/UI/ReduxForm';
import style from './styles/style.module.css';

const initialState = {
    error: null,
};
class EmailShareForm extends PureComponent {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            ...initialState,
        };
    }
    submit( values ) {
        this.props.submitHandler( values )
        .then( () => {
            this.setState( { ...initialState } );
            this.props.reset();
            this.props.closeModal();
        } )
        .catch( () => {
            this.setState( { error: 'Failed to send email' } );
        } );
    }
    render() {
        const { handleSubmit, pristine, submitting, valid } = this.props;
        return (
            <Form className={ style.shareEmailForm } onSubmit={ handleSubmit( this.submit ) }>
                <Field
                label='E-mail Address*'
                component={ FormTextField }
                fullWidth
                validate={ reduxFormValidateEmailAddress }
                name='emailAddress' />
                <Field
                label='Personal Message'
                component={ FormTextArea }
                fullWidth
                name='message' />
                <div className={ style.submitButton }>
                    <PrimaryButton
                    label='Share'
                    disabled={ pristine || submitting || !valid }
                    fullWidth
                    type='submit' />
                    { this.state.error &&
                        <div className={ style.errorBlock }>{ this.state.error }</div>
                    }
                </div>
            </Form>
        );
    }
}
EmailShareForm.defaultProps = {
    submitHandler: ()=>{},
};

EmailShareForm = reduxForm({
    form: 'EmailShareForm',
})( EmailShareForm );

export default connect()( EmailShareForm );
